import { replace } from 'lodash';
import React from 'react';
import Alert from 'react-s-alert';

export const CLASS_WARNING = 's-alert-warning';
export const CLASS_ERROR = 's-alert-error';
export const CLASS_SUCCESS = 's-alert-success';
export const CLASS_FTW = 'ftw';
export const CLASS_WHOOPS = 'whoops';

export interface IFlashProps {
  id: string;
  classNames: string;
  message: string | JSX.Element;
  styles: object;
  customFields: {
    title?: string;
    icon?: string;
  };
}

export const Flash: React.FC<IFlashProps> = ({ id, classNames, message, styles, customFields }) => {
  let className = `ui-flash ${classNames}`;
  let text = message;
  let title = '';
  let icon = '';

  // Setup classes
  if (className.indexOf(CLASS_WARNING) > -1) {
    className = replace(className, CLASS_WARNING, CLASS_WHOOPS);
    icon = 'icon-exclamation-1';
  } else if (className.indexOf(CLASS_ERROR) > -1) {
    className = replace(className, CLASS_ERROR, CLASS_WHOOPS);
    icon = 'icon-exclamation-1';
  } else if (className.indexOf(CLASS_SUCCESS) > -1) {
    className = replace(className, CLASS_SUCCESS, CLASS_FTW);
    icon = 'icon-confirm-1';
  }

  // Add custom title if available
  if (customFields.title) {
    title = customFields.title;
  }

  // Add custom icon if available
  if (customFields.icon) {
    icon = customFields.icon;
  }

  // Wrap string messages in <p> tag
  if (typeof message === 'string') {
    text = <p>{message}</p>;
  }

  return (
    <div id={id} className={className} style={styles}>
      {icon && <span className={`ui-flash__icon ${icon}`} />}
      <span role="button" className="ui-flash__close" onClick={() => Alert.close(id)} />
      <div className="ui-flash__body">
        {title && <h4>{title}</h4>}
        {text}
      </div>
    </div>
  );
};
